/**
 * Geometry shared by the real mega nav and its loading placeholder. Dependency-free on
 * purpose: the placeholder ships in the flag-off bundle, the nav does not, and the two
 * must have identical dimensions so the swap causes no layout shift.
 *
 * Values are px or theme `space` indices, as named.
 */
export const MEGA_NAV_GEOMETRY = {
  /** Desktop bar: `padding: barPaddingTopPx 0 space[barPaddingBottomSpace]`, items spaced by space[barGapSpace]. */
  barPaddingTopPx: 6,
  barPaddingBottomSpace: 2,
  barGapSpace: 2,
  /** Desktop trigger: height, horizontal padding (space index), font size. */
  triggerHeightPx: 36,
  triggerPaddingXSpace: 4,
  triggerFontSizePx: 15,
  /** Mobile strip list: `padding: space[stripPaddingYSpace] space[stripPaddingXSpace]`, chips spaced by space[stripGapSpace]. */
  stripPaddingYSpace: 3,
  stripPaddingXSpace: 6,
  stripGapSpace: 2,
  /** Mobile chip: height, left/right padding px, font size. */
  chipHeightPx: 36,
  chipPaddingLeftPx: 14,
  chipPaddingRightPx: 10,
  chipFontSizePx: 14,
  /** Chevron icon width reserved inside a chip (joykit `size="sm"`), plus the gap before it. */
  chipIconPx: 16,
  chipIconGapSpace: 1,
} as const;
